function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import last from 'lodash/last';
/** *******************Select************************** */

/** *******************Panel************************** */

var loop = function loop(data, code, callback) {
  data.forEach(function (item, index, arr) {
    if (item.code === code) {
      return callback(item, index, arr);
    }

    if (item.children && item.children.length) {
      return loop(item.children, code, callback);
    }

    return null;
  });
};

export function buildSelectedData(data, selectedCodes) {
  if (!data || !data.length) {
    return [];
  }

  if (!selectedCodes || !selectedCodes.length) {
    return data;
  }

  var selectedCode = last(selectedCodes);
  var selectedData = null;
  loop(data, selectedCode, function (item) {
    selectedData = item.children;
  });
  return selectedData;
}
export function buildBreadcrumbData(data, selectedCodes, rootName) {
  if (!data || !data.length) {
    return [];
  }

  var codes = [data.code].concat(_toConsumableArray(selectedCodes));
  var breadcrumbData = [{
    name: rootName,
    code: 'rootCode'
  }];
  codes.forEach(function (code) {
    loop(data, code, function (item) {
      breadcrumbData.push({
        code: item.code,
        name: item.name
      });
    });
  });
  return breadcrumbData;
}
export function buildSelectedCodes(selectedCodes, code) {
  var index = selectedCodes.indexOf(code);
  return selectedCodes.slice(0, index + 1);
}
export function getSearchResult(data) {
  return data ? data.map(function (item) {
    return _objectSpread({}, item, {
      code: item.code,
      name: item.name
    });
  }) : [];
}
//# sourceMappingURL=util.js.map
